import { useChartTypePersisted } from '../../recoil';
import BufferDropdown from '../common/BufferDropdown';

export const chartTypes = {
  Bar: {
    type: 0,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 25 25"
        fill="none"
        className="chart-type w-4/5 ele m-auto"
      >
        <path
          d="M6.13171 3.39618V16.3996H3.12659V19.3996H6.13171V21.3647H9.13171V13.3974H12.1266V10.3974L9.13171 10.3974V3.39618H6.13171Z"
          fill="currentColor"
        ></path>
        <path
          d="M15.1289 3.39618V5.40326H12.1266V8.40326H15.1289V21.3647H18.1289V16.3981H21.1266V13.3981H18.1289V3.39618H15.1289Z"
          fill="currentColor"
        ></path>
      </svg>
    ),
  },
  Candle: {
    type: 1,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 25 25"
        fill="none"
        className="chart-type w-4/5 ele m-auto"
      >
        <path
          d="M19.1266 3.55127H16.1266V7.55127H13.1266V17.5513H16.1266V21.5513H19.1266V17.5513H22.1266V7.55127H19.1266V3.55127Z"
          fill="currentColor"
        ></path>
        <path
          d="M11.1266 11.5513H8.12659V7.55127H5.12659V11.5513H2.12659V17.5513H5.12659V21.5513H8.12659V17.5513H11.1266V11.5513Z"
          fill="currentColor"
        ></path>
      </svg>
    ),
  },
  Area: {
    type: 3,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 25 25"
        fill="none"
        className="w-4/5 ele m-auto"
      >
        <path
          d="M19.0035 1.04468L10.0963 9.95175L6.59593 6.46205L0.988159 12.0698L3.10948 14.1911L6.59917 10.7015L10.0995 14.1911L21.1248 3.16601L19.0035 1.04468Z"
          fill="currentColor"
        ></path>
        <path
          d="M21.1266 21.1653V7.16528L10.1266 18.1653H10.1227L6.62463 14.6672L3.12659 18.1653V21.1653H21.1266Z"
          fill="currentColor"
        ></path>
      </svg>
    ),
  },
  Line: {
    type: 2,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 25 25"
        fill="none"
        className="w-4/5 ele m-auto"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.1266 5.0127H3.12659V19.0127H21.1266V5.0127ZM13.6267 15.2796L19.1258 9.78046L17.358 8.0127L13.6267 11.744L10.6267 8.74405L5.12659 14.2441L6.89435 16.0119L10.6267 12.2796L13.6267 15.2796Z"
          fill="currentColor"
        ></path>
      </svg>
    ),
  },
  Baseline: {
    type: 10,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 25 25"
        fill="none"
        className="w-4/5 ele m-auto"
      >
        <path
          d="M21.1267 4.09009L14.6266 10.5902L10.1468 6.13251L2.07397 14.2053L4.1953 16.3266L10.152 10.3699L14.6318 14.8276L23.248 6.21141L21.1267 4.09009Z"
          fill="currentColor"
        ></path>
        <path
          d="M3.12659 18.3205H6.12659V21.3205H3.12659V18.3205Z"
          fill="currentColor"
        ></path>
        <path
          d="M8.12659 18.3205H11.1266V21.3205H8.12659V18.3205Z"
          fill="currentColor"
        ></path>
        <path
          d="M13.1266 18.3205H16.1266V21.3205H13.1266V18.3205Z"
          fill="currentColor"
        ></path>
        <path
          d="M18.1266 18.3205H21.1266V21.3205H18.1266V18.3205Z"
          fill="currentColor"
        ></path>
      </svg>
    ),
  },
  // 'Heikin-Ashi': {
  //   type: 8,
  //   icon: (
  //     <svg
  //       xmlns="http://www.w3.org/2000/svg"
  //       viewBox="0 0 25 25"
  //       fill="none"
  //       className="w-4/5 ele m-auto"
  //     >
  //       <path
  //         d="M8.12659 6.63989H11.1266V15.6239H2.12659V6.63989H5.12659V2.63989H8.12659V6.63989Z"
  //         fill="currentColor"
  //       ></path>
  //       <path
  //         d="M19.1266 3.62817H16.1266L16.1266 7.62817H13.1266V21.6282H22.1266V7.62817H19.1266V3.62817Z"
  //         fill="currentColor"
  //       ></path>
  //     </svg>
  //   ),
  // },
  'Hollow Candles': {
    type: 9,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 25 25"
        fill="none"
        className="w-4/5 ele m-auto"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.1266 3.70508H19.1266V7.70508H22.1266V17.7041H19.1266V21.7041H16.1266L16.1266 17.7041H13.1266V7.70508H16.1266L16.1266 3.70508ZM19.1266 10.7051H16.1266V14.7041H19.1266V10.7051Z"
          fill="currentColor"
        ></path>
        <path
          d="M8.12659 11.7051H11.1266V17.7051H8.12659V21.7051H5.12659V17.7051H2.12659V11.7051H5.12659V7.70508H8.12659V11.7051Z"
          fill="currentColor"
        ></path>
      </svg>
    ),
  },
  // 'Hi-Lo': {
  //   type: 12,
  //   icon: (
  //     <svg
  //       xmlns="http://www.w3.org/2000/svg"
  //       viewBox="0 0 25 25"
  //       fill="none"
  //       className="w-4/5 ele m-auto"
  //     >
  //       <path
  //         fillRule="evenodd"
  //         clipRule="evenodd"
  //         d="M16.1266 3.70508H19.1266V7.70508H22.1266V17.7041H19.1266V21.7041H16.1266L16.1266 17.7041H13.1266V7.70508H16.1266L16.1266 3.70508ZM19.1266 10.7051H16.1266V14.7041H19.1266V10.7051Z"
  //         fill="currentColor"
  //       ></path>
  //       <path
  //         d="M8.12659 11.7051H11.1266V17.7051H8.12659V21.7051H5.12659V17.7051H2.12659V11.7051H5.12659V7.70508H8.12659V11.7051Z"
  //         fill="currentColor"
  //       ></path>
  //     </svg>
  //   ),
  // },
  Column: {
    type: 12,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 25 25"
        fill="none"
        className="w-4/5 ele m-auto"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.1266 3.70508H19.1266V7.70508H22.1266V17.7041H19.1266V21.7041H16.1266L16.1266 17.7041H13.1266V7.70508H16.1266L16.1266 3.70508ZM19.1266 10.7051H16.1266V14.7041H19.1266V10.7051Z"
          fill="currentColor"
        ></path>
        <path
          d="M8.12659 11.7051H11.1266V17.7051H8.12659V21.7051H5.12659V17.7051H2.12659V11.7051H5.12659V7.70508H8.12659V11.7051Z"
          fill="currentColor"
        ></path>
      </svg>
    ),
  },
  'Heikin-Ashi': {
    type: 8,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 25 25"
        fill="none"
        className="w-4/5 ele m-auto"
      >
        <path
          d="M8.12659 6.63989H11.1266V15.6239H2.12659V6.63989H5.12659V2.63989H8.12659V6.63989Z"
          fill="currentColor"
        ></path>
        <path
          d="M19.1266 3.62817H16.1266L16.1266 7.62817H13.1266V21.6282H22.1266V7.62817H19.1266V3.62817Z"
          fill="currentColor"
        ></path>
      </svg>
    ),
  },
};


const ChartTypeSelectionDD: React.FC<{
  active: string;
  setActive: any;
  isMobile?: boolean;
}> = ({ active, setActive, isMobile }) => {
  const find = Object.keys(chartTypes).find(
    // @ts-ignore
    (c) => chartTypes[c].type == active
  );

  if (isMobile)
    return (
      <div className="flex flex-wrap items-center justify-center ">
        {Object.entries(chartTypes).map(([key, value]) => (
          <div
            onClick={(e) => {
              setActive(value.type);
            }}
            className={`flex my-3 flex-col w-[80px] items-center  ${
              // @ts-ignore
              value.type == active ? 'text-1' : 'text-2'
              }`}
            key={value.type}
          >
            <div className="w-[30px] h-[30px]">{value.icon}</div>
            <div className={`text-center `}>{key.replace('_', ' ')}</div>
          </div>
        ))}
      </div>
    );

  return (
    <div>
      <>
        <BufferDropdown
          items={Object.keys(chartTypes).map((s) => ({
            name: s,
            // @ts-ignore
            value: chartTypes[s],
          }))}
          className={'chart-type-dd '}
          initialActive={0}
          dropdownBox={() => (
            <div className="flex whitespace-nowrap chart-type items-center mr-5 text-f11 ele">
              {// @ts-ignore
                chartTypes[find].icon}
              Chart Type
            </div>
          )}
          rootClass={'!w-[fit-content]'}
          item={(item) => {
            return (
              <div
                onClick={(e) => {
                  setActive(item.value.type);
                }}
                className={`chart-type my-2 ${active == item.value.type ? 'active-chart' : ''
                  }`}
                key={item.name}
              >
                {item.value.icon}
                <span className="ele whitespace-nowrap">
                  {item.name.replace('_', ' ')}
                </span>
              </div>
            );
          }}
        ></BufferDropdown>
      </>
    </div>
  );
};

const ChartElementSVG = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={18}
    height={18}
    fill="none"
    className="css-9698k2"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 20h3v-6.791l3.767-3.767.967.966 1.767 1.768 6.364-6.364-1.767-1.768-4.596 4.596-.967-.966-1.768-1.768L7 9.673V4H4v16zm16 0H7v-3h13v3zm-6.5-7.823 2.828 2.828h-5.656l2.828-2.828z"
      fill="currentColor"
    />
  </svg>
);

export { ChartTypeSelectionDD, ChartElementSVG };
